import React from "react";
import { bool, string } from "prop-types";
import Snackbar from "@techsoftware/happay-widgets/Snackbar";

export default class CustomSnackbar extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    _handleCloseRequest = () => {
        this.props.onRequestClose();
    };

    render() {
        const { open, message, autoHideDuration, position, type, showIcon } = this.props;

        return (
            <Snackbar
                id="expense-snackbar"
                message={message}
                showSnackbar={open}
                position={position}
                type={type}
                showIcon={showIcon}
                snackBarTime={autoHideDuration || 4000}
                onClose={this._handleCloseRequest}
            />
        );
    }
}

CustomSnackbar.propTypes = {
    open: bool,
    position: string,
    message: string,
    type: string,
    showIcon: bool
};

CustomSnackbar.defaultProps = {
    open: false,
    position: "center-bottom",
    message: "Something Went Wrong!",
    type: "success",
    showIcon: true
};
